<template>
    <div class="pin-dialog">
        <HLCardLayout class="pt-0" :class="{'fixed-width': !isXsDevice, 'full-width': isXsDevice}" :scale="(isXsDevice)?0.75:(isXlDevice)?0.4:0.7" :loading="false" :minHeight="(isSmAndUpDevice)?'600':null" disableFooterPadding :horizontalMargin="!isXsDevice">
            <template #header-action>
                <!-- close btn -->
            </template>

            <template #menuTitle>
                <h3 class="three-dots px-sm-6 grey--text text--darken-3" :class="{'text-center':true}">{{$t('pin')}}</h3>
            </template>

            <!-- Content -->
            <template #content>
                <div class="pin-input-container pa-4">
                    <div class="content-wrapper">
                        <!-- Lock Icon -->
                        <div class="lock-icon-container mb-6 mb-sm-8 mb-md-12">
                            <v-icon 
                                class="lock-icon" 
                                size="48"
                            >
                                mdi-lock-outline
                            </v-icon>
                        </div>

                        <div class="text-center mb-4 mb-sm-6">
                            {{$t('pinMsg')}}
                        </div>
                        
                        <v-text-field
                            v-model="pin"
                            :label="$t('pin')"
                            :placeholder="$t('pinHint')"
                            type="text"
                            outlined
                            @keyup.enter="onSubmit"
                            ref="pinInput"
                            :error="hasError"
                            :error-messages="errorMessage"
                            :class="{ 'shake-horizontal': pinIsInValid }"
                            maxlength="10"
                        ></v-text-field>
                    </div>

                    <div class="text-center mt-4 button-container">
                        <v-btn
                            @click="onSubmit"
                            large
                            block
                            depressed
                            rounded
                            :dark="isValidPin && !isLoading"
                            :color="theme.buttonGreen"
                            :disabled="!isValidPin || isLoading"
                            class="mb-3"
                        >
                            {{$t('ok')}}
                        </v-btn>
                        
                        <v-btn
                            @click="onCancel"
                            large
                            block
                            depressed
                            rounded
                            dark
                            :opacity="0.8"
                        >
                            {{$t('close')}}
                        </v-btn>
                    </div>
                </div>
            </template>

        </HLCardLayout>
    </div>
</template>

<script>
import {layoutMixin} from "../../utils/layout-mixin";
import {eventMixin} from "../../utils/event-mixin";
import HLCardLayout from "../../components/dashboard/HLCardLayout.vue";

export default {
    mixins: [layoutMixin, eventMixin],
    components:{
        HLCardLayout
    },
    data(){
        return {
            pin: '',
            isLoading: false,
            hasError: false,
            errorMessage: '',
            pinIsInValid: false
        }
    },
    computed: {
        isValidPin(){
            if(typeof(this.pin)=="string" && this.pin.length > 0){
                const dotCount = (this.pin.match(/\./g) || []).length;
                if(dotCount === 1){
                    const parts = this.pin.split('.');
                    return parts.length === 2 && parts[0].length > 0 && parts[1].length > 0;
                }
            }
            return false;
        },
    },
    methods: {
        onSubmit(){
            if (!this.isValidPin || this.isLoading) {
                return;
            }
            this.isLoading = true;
            this.hasError = false;
            this.errorMessage = '';
            this.pinIsInValid = false;
            
            const pinData = { pin: this.pin };
            this.readNewPin(pinData).then(qrData => {
                this.$emit('submit', qrData);
            }).catch(() => {
                this.isLoading = false;
                this.showFailAnimation();
            });
        },
        onCancel(){
            this.$emit('cancel');
        },
        reset(){
            this.pin = '';
            this.isLoading = false;
            this.hasError = false;
            this.errorMessage = '';
            this.pinIsInValid = false;
        },
        showFailAnimation() {
            this.pinIsInValid = true;
            this.hasError = true;
            this.errorMessage = this.$t('errorCodeInvalidPin');
            setTimeout(() => {
                this.pinIsInValid = false;
            }, 1000);
        },
    },
    mounted() {
        this.reset();
        this.$nextTick(() => {
            if (this.$refs.pinInput) {
                this.$refs.pinInput.focus();
            }
        });
    },
}
</script>

<style lang="scss">
.pin-input-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    
    .content-wrapper {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    
    .v-text-field {
        .v-input__control {
            .v-input__slot {
                background-color: rgba(255, 255, 255, 0.1);
            }
        }
    }
}

.button-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.lock-icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    
    .lock-icon {
        border-radius: 50%;
        padding: 16px;
        border: 2px solid;
        width: 80px;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.fixed-width {
    width: 680px;
    max-width: 90vw;
}
.full-width {
    width: 100vw;
    max-width: 100vw;
}

.shake-horizontal {
    -webkit-animation: shake-horizontal 0.8s cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
    animation: shake-horizontal 0.8s cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
}

@-webkit-keyframes shake-horizontal {
    0%,
    100% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
    }
    10%,
    30%,
    50%,
    70% {
        -webkit-transform: translateX(-10px);
        transform: translateX(-10px);
    }
    20%,
    40%,
    60% {
        -webkit-transform: translateX(10px);
        transform: translateX(10px);
    }
    80% {
        -webkit-transform: translateX(8px);
        transform: translateX(8px);
    }
    90% {
        -webkit-transform: translateX(-8px);
        transform: translateX(-8px);
    }
}
@keyframes shake-horizontal {
    0%,
    100% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
    }
    10%,
    30%,
    50%,
    70% {
        -webkit-transform: translateX(-10px);
        transform: translateX(-10px);
    }
    20%,
    40%,
    60% {
        -webkit-transform: translateX(10px);
        transform: translateX(10px);
    }
    80% {
        -webkit-transform: translateX(8px);
        transform: translateX(8px);
    }
    90% {
        -webkit-transform: translateX(-8px);
        transform: translateX(-8px);
    }
}
</style>

